// Чем человек ведёт по списку cmdk (палитра, выбор с поиском): клавишами или указателем.
// В cmdk фокус остаётся в поле ввода, а выбранный пункт отмечен data-selected — и при наведении
// тоже, поэтому :focus-visible здесь не помогает. Пункт, выбранный клавишами, получает обводку
// фокуса 2 px color-accent (README «Состояния»), пункт под указателем — только фон color-subtle.
import { useState } from 'react';

export type ListNav = 'keys' | 'pointer';

export interface ListNavState {
  /** Значение data-nav у слоя: по нему kp.css рисует обводку выбранного пункта. */
  nav: ListNav;
  /** На корень cmdk: любая клавиша — снова клавиатура (ввод тоже выбирает первый пункт). */
  onKeyDown: () => void;
  /** На список cmdk: указатель двинулся над пунктами. */
  onPointerMove: () => void;
}

/**
 * Каждое открытие слоя начинается с клавиатуры: Enter сработает на выбранном пункте — его видно
 * сразу.
 */
export function useListNav(open: boolean): ListNavState {
  const [nav, setNav] = useState<ListNav>('keys');
  const [wasOpen, setWasOpen] = useState(open);
  if (wasOpen !== open) {
    setWasOpen(open);
    if (open) setNav('keys');
  }
  return {
    nav,
    onKeyDown: () => setNav('keys'),
    onPointerMove: () => setNav('pointer'),
  };
}
